<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Sobre a Freire Imóveis';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">

	<iframe width="100%" height="600" src="https://www.youtube.com/embed/SM5fVXPTEyk" title="Freire Imóveis" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

	<hr>

</div>